import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import { default as FeedBox } from './FeedBox';
import { default as FeedBoxV2 } from '../Feed__posts_feed_module';

export default withFeatureBranch({
  posts_feed_module: FeedBoxV2,
})(FeedBox as any);
